<app-top-view></app-top-view>
<app-report-main></app-report-main>

<div class="component-main-navigation-overlay" (click)="hideNavigation()"></div>
